import { Component, OnInit } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
  selector: "app-general",
  templateUrl: "./general.component.html",
  styleUrls: ["./general.component.css"]
})
export class GeneralComponent implements OnInit {

  constructor(private readonly titleService: Title) {
    this.titleService.setTitle("Supplier Recognition");
    (window as any).adobeDataLayer.push({
      page: {
        pageName: this.titleService.getTitle()
      }
    });
  }

  ngOnInit() {}
}
